 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		26: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		26: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"1bfc9850","2":"ae69f671ad13b7f2e99874c7b068948646b334a6","3":"d7eeaac4","4":"e7774efd49469e1b74904e01d1969860b8055418","5":"00b602d62d2c1e4c26d48f200fbf18fad748d716","6":"9e167d77f8067b1d4e3cc4eb1b6d64751e963860","7":"6d6ccb2634ba5b43b9d6ce7004e6a3ad1eb7d1f0","8":"b98bc7c3","9":"fe00fe20c6a0b9b839d37ac4d73f14a028755f4e","10":"8cc3c97e4eb80e7a3322b98b2dcaf19550b2e002","11":"ee9b19353cb0065126ead98fe8742c2b8a8d9428","12":"7ef9fce1dc4c50e2556f62cce982dff7e97de969","13":"acfab35638e6cf0581087a0654025195a9975ee7","14":"2c796e83","15":"3ef2d0457f73aa3dfb073e20eee837fd5f29dd8b","16":"c29b6840b772645d3249e43dd834402cf8b0c6c3","17":"fe41ad276b2cde27d6bc3eb12b70e4996522d168","18":"5e2a4920","19":"6c6178acb1d4c03b869c92923e93c5b908041941","20":"1c4c8d39912e612d9c44503eb24f6bb58c40d662","21":"7a663ca2f71f1c972a7095a83d5125d90705232f","22":"1a48c3c1","23":"482a17eb9a9d8c1f69353613f5cd217cbb42fb70","24":"98d411dd056a4624676d82727c3c2a51edf05b5e","27":"0c428ae2","28":"252f366e","29":"95b64a6e","31":"component---cache-caches-gatsby-plugin-offline-app-shell-js","32":"component---src-pages-404-js","33":"component---src-pages-about-csr-js","34":"component---src-pages-about-faq-js","35":"component---src-pages-about-index-js","36":"component---src-pages-about-privacy-js","37":"component---src-pages-about-terms-js","38":"component---src-pages-collections-js","39":"component---src-pages-index-js","40":"component---src-pages-product-preview-index-js","41":"component---src-pages-search-js","42":"component---src-pages-support-js","43":"component---src-pages-user-account-index-js","44":"component---src-pages-user-auth-index-js","45":"component---src-pages-user-favourites-index-js","46":"component---src-templates-collection-index-js","47":"component---src-templates-product-index-js","48":"d64684d8"}[chunkId]||chunkId) + "-" + {"0":"407fe62976dc5310c43e","1":"e9d88db61b197b08523c","2":"48834b379146190b1a57","3":"05e9c5b43c0e18a948dc","4":"63448d7b92689ec48c0c","5":"da47766487b29ee3676b","6":"a2db9dce0681838ead1d","7":"2730307d6cefb41ef985","8":"1d719041ec15214fa9db","9":"84953d9300c314c7c7fa","10":"e1b804a4d19d50ec8a9f","11":"14a341361a6532201adf","12":"085aa13abc0900516d41","13":"76a557739d9a9a8dc00a","14":"2cb4d055de90d4943588","15":"96655b798213c2b98f2b","16":"faca0ded94c422ecc0b2","17":"b7d32b639cc790c92558","18":"32630f569a54b92197f8","19":"478121027eb87e3ef023","20":"b2d3b44dbe28dd293edb","21":"9266e8bb7b4095951d20","22":"d2e77bd8a2ea18f24062","23":"1e05347431f121a21cd7","24":"d3809dc083e6ca132743","27":"991aa30965694c0d4286","28":"2448ad3283432505f246","29":"eb42e36e2a6a24eb6bf7","31":"1a0280ee8b291ca56fa2","32":"f2317d00655b391f20fa","33":"fcae0d04ae3c4826b55a","34":"efef3e4ec35ef0886abc","35":"c9e6e98efa9f51ca0b5b","36":"49aa58aa9e3af4d79956","37":"24acf9ed00699d210590","38":"75b211c17a8234dbc67d","39":"49d583166c34ef7838a3","40":"5e70c83f93d12f80bdfd","41":"e7868276466077c0d176","42":"705822acc5154bd95318","43":"288b497dc946e1426a7c","44":"f161cf8a028099992a47","45":"825dde69d665caa3def6","46":"d678052d3dea25d2e970","47":"5f3805e251a652ae8eb0","48":"4bb46325ad6f54188a2b"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"1bfc9850","2":"ae69f671ad13b7f2e99874c7b068948646b334a6","3":"d7eeaac4","4":"e7774efd49469e1b74904e01d1969860b8055418","5":"00b602d62d2c1e4c26d48f200fbf18fad748d716","6":"9e167d77f8067b1d4e3cc4eb1b6d64751e963860","7":"6d6ccb2634ba5b43b9d6ce7004e6a3ad1eb7d1f0","8":"b98bc7c3","9":"fe00fe20c6a0b9b839d37ac4d73f14a028755f4e","10":"8cc3c97e4eb80e7a3322b98b2dcaf19550b2e002","11":"ee9b19353cb0065126ead98fe8742c2b8a8d9428","12":"7ef9fce1dc4c50e2556f62cce982dff7e97de969","13":"acfab35638e6cf0581087a0654025195a9975ee7","14":"2c796e83","15":"3ef2d0457f73aa3dfb073e20eee837fd5f29dd8b","16":"c29b6840b772645d3249e43dd834402cf8b0c6c3","17":"fe41ad276b2cde27d6bc3eb12b70e4996522d168","18":"5e2a4920","19":"6c6178acb1d4c03b869c92923e93c5b908041941","20":"1c4c8d39912e612d9c44503eb24f6bb58c40d662","21":"7a663ca2f71f1c972a7095a83d5125d90705232f","22":"1a48c3c1","23":"482a17eb9a9d8c1f69353613f5cd217cbb42fb70","24":"98d411dd056a4624676d82727c3c2a51edf05b5e","27":"0c428ae2","28":"252f366e","29":"95b64a6e","31":"component---cache-caches-gatsby-plugin-offline-app-shell-js","32":"component---src-pages-404-js","33":"component---src-pages-about-csr-js","34":"component---src-pages-about-faq-js","35":"component---src-pages-about-index-js","36":"component---src-pages-about-privacy-js","37":"component---src-pages-about-terms-js","38":"component---src-pages-collections-js","39":"component---src-pages-index-js","40":"component---src-pages-product-preview-index-js","41":"component---src-pages-search-js","42":"component---src-pages-support-js","43":"component---src-pages-user-account-index-js","44":"component---src-pages-user-auth-index-js","45":"component---src-pages-user-favourites-index-js","46":"component---src-templates-collection-index-js","47":"component---src-templates-product-index-js","48":"d64684d8"}[chunkId]||chunkId) + "." + {"0":"0b466784658af0125bd2","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
